import { theme, parse } from "@config/theme";
import { css } from "linaria";
import { rem } from "polished";
export const container = parse({
  position: "absolute",
  width: "100%",
  height: "100%"
}, "c1jix9i8");
export const image = parse({
  position: "absolute",
  width: "100%",
  height: "100%"
}, "ijjigkt");
export const content = parse({
  position: "absolute"
}, "cxi63he");

require("./HeroItem.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./HeroItem.styles.ts");